import { Outlet } from "react-router-dom";
import styles from "../component/mainpage/MainPage.module.css";
import Navbar from "../component/navbar/Navbar";
import Footer from "../component/footer/Footer";

const Layout = () => {
  return (
    <div className={styles.page}>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;